import React from 'react';
import {
  MaintenanceContainer,
  TextContainer,
  IconContainer,
  Title,
} from './style';
import IconMaintenance from '../../../ui/assets/img/maintenance.svg';
import Text from '../../../ui/atoms/Text';

const Maintenance = () => (
  <MaintenanceContainer>
    <TextContainer>
      <Title>
        <Text type="h1">Stiamo lavorando per tornare con tante novità!</Text>
      </Title>
    </TextContainer>
    <IconContainer>
      <img src={IconMaintenance} alt="maintenance" />
    </IconContainer>
  </MaintenanceContainer>
);

export default Maintenance;
